module.exports = __webpack_public_path__ + "static/media/7.2a14a0b2.jpg";